import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from './auth.service';
import { PermissionService } from './permission.service';

/**
 * Restringe a rota às permissões `module:action` declaradas em `data.permissions`.
 * Pós-flip: libera se o usuário possui ao menos uma das permissões exigidas (sem
 * mais bypass por grupo ADMIN). Sem `permissions`, libera qualquer autenticado.
 * Negado → `/acesso-negado`. É apenas UX — o enforcement real vive no
 * authorizer/backend.
 */
export const permissionGuard: CanActivateFn = async (route) => {
  const auth = inject(AuthService);
  const permissions = inject(PermissionService);
  const router = inject(Router);

  if (!auth.user()) {
    await auth.refreshUser();
  }

  await permissions.ensureLoaded();
  const required = route.data?.['permissions'] as readonly string[] | undefined;
  if (permissions.canAny(required)) {
    return true;
  }

  return router.createUrlTree(['/acesso-negado']);
};
